import React from 'react';
import * as styles from './languageSelect.module.css';
import { StaticImage } from 'gatsby-plugin-image';

const LanguageSelect = () => {
  let newUrl = '/';
  let isEn = false;
  if (typeof document !== 'undefined') {
    const { href } = document.location;
    isEn = href.includes('/en/') || href.endsWith('/en');
    const { origin, pathname } = document.location;

    if (pathname === '/') {
      newUrl = origin + (isEn ? '/' : '/en');
    } else {
      const newPathName = isEn
        ? pathname.replace(/^\/en(?=\/|$)/, '') // Remove /en only from the start
        : `/en${pathname}`; // Add /en to the start
      newUrl = origin + newPathName;
    }
  }

  const handleLanguageChange = (e) => {
    e.preventDefault(); // Prevent any default button behavior
    window.location.href = newUrl;
  };

  return (
    <button
      onClick={handleLanguageChange}
      className={styles.link}
      style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer' }}
    >
      <div className={styles.root}>
        {isEn ? (
          <StaticImage
            src={`../media/flag_en.webp`}
            alt="Left decoration"
            className={styles.flag}
            objectFit="contain"
          />
        ) : (
          ''
        )}
        {!isEn ? (
          <StaticImage
            src={`../media/flag_ru.webp`}
            alt="Left decoration"
            className={styles.flag}
            objectFit="contain"
          />
        ) : (
          ''
        )}
        <div className={styles.dropdown}>
          <div className={styles.back}></div>
          <span>{isEn ? 'Русский' : 'English'}</span>
          {!isEn ? (
            <StaticImage
              src={`../media/flag_en.webp`}
              alt="Left decoration"
              className={styles.flag}
              objectFit="contain"
            />
          ) : (
            ''
          )}
          {isEn ? (
            <StaticImage
              src={`../media/flag_ru.webp`}
              alt="Left decoration"
              className={styles.flag}
              objectFit="contain"
            />
          ) : (
            ''
          )}
        </div>
      </div>
    </button>
  );
};

export default LanguageSelect;
